module.exports = __webpack_public_path__ + "img/responsive crc-01.e3e3da98.jpg";